import { filter, firstValueFrom } from 'rxjs';
import { AuthService } from '../auth.service';

export const initializeAuth = (authService: AuthService) => {
  authService.initAuth();
  return firstValueFrom(
    authService.tenantInfo$.pipe(filter((tenantInfo) => !!tenantInfo)),
  );
};
